import React, { useState } from "react";
import { ModalFooter, ModalBody,
  ModalHeader, Modal, Button } from "reactstrap";
import { Field, getFormValues, InjectedFormProps, reduxForm } from "redux-form";
import { connect } from "react-redux";
import SelectField from "../../commonfields/SelectField";
import UserIcon from "../../images/user.svg";
import EllipsisTooltip from "../../utils/EllipsisTooltip";
import userEvent from "@testing-library/user-event";





interface ReAssignModalProps {
  leaddetails: any;
  toggleModal: () => void;
  reassignModal: boolean;
  user?: any;
  reAssignClient: (assignedTo: string) => void;
}
const TooltipWrapper = (content: string = "") => {
  return (
    <div className="lable tooltip-container">
      <span className="title">
        {content.length > 20 ? content.substring(0, 20) + "..." : content}
      </span>

      {content.length > 20 && <span className="tooltiptext">{content}</span>}
    </div>
  );
};


const ReassignModal: React.FC<ReAssignModalProps & InjectedFormProps<Record<string, unknown>, ReAssignModalProps>
> = (props: any) => { 
  const [assignUser,setAssignUser] = useState("")
           
   const chngeAssignee = (e:any) => {  
  setAssignUser(e)
   }
  return (
    <Modal
      className="reAssignModal"
      isOpen={props?.reassignModal}
      toggle={props?.toggleModal}

    >
      <ModalHeader toggle={props?.toggleModal}></ModalHeader>
      <ModalBody>
        <div className="reassignModalBody">
          <h1 className="title">Assign Client</h1>
          <span className="clientNameBlk">
              {/* <p className="clientName"> {props?.leaddetails?.[0]?.businessInfo?.[0].businessName||"--"}</p> */}
              <p className="clientName"> 
                <EllipsisTooltip
                      text={
                        props?.leaddetails?.[0]?.businessInfo?.[0].businessName||"--"
                      }
                      maxLine={20}
                    ></EllipsisTooltip></p>
              <p>
                  <img className="usericon" src={UserIcon} alt="user" />
                  <span className="clientPosition">{props?.leaddetails?.[0]?.clientProducts?.[0].assignto|| "--" }</span>
                
              </p>
          </span>
          <form>
              <Field
                  component={SelectField}
                  type="text"
                  name="assignTo"
                  label="Assign To:"
                  values={props?.user?.map((v:any)=>{v.value=v.id; return v})}
                  onChange={chngeAssignee}
              />
               
          </form>
          
      </div>
      </ModalBody>
      <ModalFooter>
        <div className="footerBlk">
          <Button 
            className="assignBtn" 
            disabled={props?.pristine || props?.submitting || props?.invalid}
            onClick={() => props.reAssignClient(assignUser)}
          >
            Assign
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default connect((state: Record<string, unknown>) => {
  return {
    initialValues: {},
    formValues: getFormValues("ReassignModal")(state),
  };
})(
  reduxForm<Record<string, unknown>, ReAssignModalProps>({
    form: "ReassignModal",
    enableReinitialize: true,
  })(ReassignModal)
);

